import { Component, Injectable } from '@angular/core';

@Injectable()
export class SharedData {
    public sharedServices:any = [];
    private tempService = {};

    constructor() {

    }
    getAllServices(){
        return this.sharedServices;
    }
    clearServiceCache(){
        this.sharedServices = [];
        this.tempService = {}
    }
    setService(service): void {
        for(let i=0;i<this.sharedServices.length;i++){
           if(service._id == this.sharedServices[i]._id){
               this.sharedServices.splice(i, 1);
               break;
           }
        }
        this.sharedServices.push(service)
    }
    getService(id) :any{
        for (let i = 0; i < this.sharedServices.length; i++) {
            if (this.sharedServices[i]._id == id) {
                return this.sharedServices[i];
            }
        }
        return null;
    }
    getTemplatesByServiceId(id):any {
        let service = this.getService(id);
        if (service) {
            return service.serviceTemplates;
        }
        return null;
    }
    setTemplateByServiceId(id, template) {
        this.getService(id).serviceTemplates.push(template);
    }
    setTempService(service: any): void{
        this.tempService = service;
    }
    getTempService():any{
        return this.tempService;
    }
    isServiceNameValid(serviceName: string): boolean{
        for(let i=0;i<this.sharedServices.length;i++){
            if(this.sharedServices[i]._id === serviceName){
                return false;
            }
        }
        return true;
    }
    isServiceUrlAndMethodValid(url:string, method:string): boolean{
        for(let i=0;i<this.sharedServices.length;i++){
            if(this.sharedServices[i].urlMethod == method &&
             this.sharedServices[i].urlPath == url){
                 return false;
            }
        }
        return true;
    }
}


// WEBPACK FOOTER //
// ./src/app/shared-data/shared-object.service.ts